import { lazy } from "react"

export const Dashboard = lazy(() => import("views/dashboard/Dashboard"))
